import { Component, effect, OnInit, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { AsyncPipe, NgClass, NgOptimizedImage } from '@angular/common';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faCaretDown, faRightFromBracket, faUserCircle } from '@fortawesome/free-solid-svg-icons';
import { ActivatedRoute, NavigationEnd, Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { AccountService } from '../login/account.service';
import { VersionService } from '../shared/service/version.service';
import { Toast } from 'primeng/toast';
import { MatToolbar } from '@angular/material/toolbar';
import { MatNavList } from '@angular/material/list';
import { ROLE_ADMIN, ROLE_MANAGER, ROLE_BUYER, ROLE_OWNER } from '../core/config/role.constants';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Breadcrumb } from 'primeng/breadcrumb';
import { MenuItem } from 'primeng/api';
import { filter, Observable } from 'rxjs';
import { ProductCartComponent } from "../orders/product-cart-component/product-cart-component";
import { WarehouseService } from '../shared/service/warehouse-service';
import { IWarehouse } from '../shared/model/warehouse.model';
import { signal } from '@angular/core';

@Component({
  selector: 'app-home',
  imports: [MatSidenavModule, MatCheckboxModule, FormsModule, MatButtonModule, NgOptimizedImage, FaIconComponent, RouterOutlet, Toast, RouterLink, MatToolbar, MatNavList, RouterLinkActive, NgClass, AsyncPipe, Breadcrumb, ProductCartComponent],
  templateUrl: './home.html',
  styleUrl: './home.css'
})
export class Home implements OnInit {
  protected readonly faUserCircle = faUserCircle;
  protected readonly faCaretDown = faCaretDown;
  protected readonly faRightFromBracket = faRightFromBracket;
  protected readonly ROLE_ADMIN = ROLE_ADMIN;
  protected readonly ROLE_MANAGER = ROLE_MANAGER;
  protected readonly ROLE_BUYER = ROLE_BUYER;
  protected readonly ROLE_OWNER = ROLE_OWNER;

  @ViewChild('sidenav') sidenav!: MatSidenav;

  events: string[] = [];
  user;
  isCollapsed = false;
  isMobile = false;
  items: MenuItem[] | undefined;
  showBreadcrumbDiv = false;
  showCart = false;
  readonly versionLabel$: Observable<string>;
  activeWarehouse = signal<IWarehouse | null>(null);

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public accountService: AccountService,
    private breakpointObserver: BreakpointObserver,
    private readonly versionService: VersionService,
    private warehouseService: WarehouseService
  ) {
    this.user = this.accountService.userIdentity;
    this.versionLabel$ = this.versionService.versionLabel$;
    effect(() => {
      const user = this.user();
    });

    effect(() => {
      const warehouseCode = this.accountService.selectedWarehouseCode();
      if (warehouseCode) {
        this.loadWarehouseInfo(warehouseCode);
      } else {
        this.activeWarehouse.set(null);
      }
    });

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.showBreadcrumbDiv = event.urlAfterRedirects.startsWith('/home/pedidos/');
      }
    });
  }

  ngOnInit() {
    this.evaluateRoute(this.router.url);

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.evaluateRoute(event.urlAfterRedirects);
      });
  }

  ngAfterViewInit() {
    this.breakpointObserver.observe([Breakpoints.Handset])
      .subscribe(result => {
        this.isMobile = result.matches;

        if (this.sidenav) {
          if (this.isMobile) {
            this.sidenav.close();
          } else {
            this.sidenav.open();
          }
        }
      });
  }
  private evaluateRoute(url: string) {
    this.buildBreadcrumb();

    const cleanUrl = this.router.url.split('?')[0];
    this.showCart = cleanUrl === '/home/pedidos/crear';

    this.isCollapsed = this.showCart;
  }

  private buildBreadcrumb(): void {
    const cleanUrl = this.router.url.split('?')[0];

    const segments = cleanUrl
      .split('/')
      .filter(seg => seg && seg !== 'home');

    this.items = segments.map((segment, index) => {
      const path = '/home/' + segments.slice(0, index + 1).join('/');
      return {
        label: this.formatLabel(segment),
        url: path,
      };
    });
  }

  private formatLabel(segment: string): string {
    return segment
      .replace(/-/g, ' ')
      .replace(/\b\w/g, (char) => char.toUpperCase());
  }

  toggleSidenav() {
    this.isCollapsed = !this.isCollapsed;
  }

  isActive(item: any): boolean {
    const cleanCurrent = this.router.url.split('?')[0];

    return cleanCurrent === item.url;
  }

  private loadWarehouseInfo(code: string) {
    this.warehouseService.findByCode(code).subscribe({
      next: (res) => {
        const responseBody = res.body as any;
        const warehouse = responseBody?.warehouse as IWarehouse;
        this.activeWarehouse.set(warehouse || null);
      },
      error: () => {
        this.activeWarehouse.set(null);
      }
    });
  }

  
}
